import { render, staticRenderFns } from "./location-row.vue?vue&type=template&id=c15e30e6&"
import script from "./location-row.vue?vue&type=script&lang=ts&"
export * from "./location-row.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports